

<div [formGroup]="form" class="form-typography">

  <div [formGroupName]="question.key" *ngIf="!raptorPaymentService.gocardlessShowAccount">
    <div class="grid" [formGroupName]="option.service">
      <!-- <div class="cell cell-small-col-span-6 cell-medium-col-span-8 cell-large-col-span-12">
        <label class="text-nowrap">Your email</label>
        <p class="text-nowrap margin-top-xxsmall margin-bottom-none">{{ option.params.user_email }}</p>
      </div> -->

      <div class="cell cell-small-col-span-6 cell-medium-col-span-8 cell-large-col-span-12">
        <div class="gocardless-field">
          <label>Account name</label>
          <mat-form-field appearance="outline">
            <input matInput type="text" formControlName="ddname" id="ddname" />
          </mat-form-field>
          <open-raptor-question-error [submitted]="raptorStepService.submitted" [question]="ddname" [form]="form"></open-raptor-question-error>
        </div>
      </div>

      <div class="cell cell-small-col-span-6 cell-medium-col-span-4 cell-large-col-span-6">
        <div class="gocardless-field">
          <label>BSB</label>
          <mat-form-field appearance="outline" class="small">
            <input matInput type="text" formControlName="ddbsb" id="ddbsb" />
          </mat-form-field>
          <open-raptor-question-error [submitted]="raptorStepService.submitted" [question]="ddbsb" [form]="form"></open-raptor-question-error>
        </div>
      </div>

      <div class="cell cell-small-col-span-6 cell-medium-col-span-4 cell-large-col-span-6">
        <div class="gocardless-field">
          <label>Account number</label>
          <mat-form-field appearance="outline" class="medium">
            <input matInput type="text" formControlName="ddaccnum" id="ddaccnum" />
          </mat-form-field>
          <open-raptor-question-error [submitted]="raptorStepService.submitted" [question]="ddaccnum" [form]="form"></open-raptor-question-error>
        </div>
      </div>

      <div class="cell cell-small-col-span-6 cell-medium-col-span-8 cell-large-col-span-12">
        <p>This{{ partnerName ? " " + partnerName : '' }} insurance cover is issued and powered by Open Insurance Pty Ltd. The insurer is Hollard.</p>
        <p class="margin-top-medium margin-bottom-large">By pressing "{{ option.pre_submit_label || 'Confirm direct debit details' }}", you are providing us with a valid instruction for this direct debit request and agree that you understood and agree to Open Insurance Pty Ltd’s direct debit terms, as shown on this page and in the "Paying your premium" and "If you have a complaint" sections of the <a (click)="openPdsDocument(pdsLink)">Product Disclosure Statement</a>.
      </div>

      <div class="cell cell-small-col-span-6 cell-medium-col-span-8 cell-large-col-span-12" *ngIf="raptorPaymentService.gocardlessErrors && raptorPaymentService.gocardlessErrors.cardFailure">
        <div class="open-form-info is-error padding-medium margin-bottom-medium">
          <p class="margin-bottom-xsmall">We&rsquo;re sorry, but we had trouble processing your transaction.</p>
          <p *ngIf="question.settings?.cta">Please check your account details and try again. If the problem continues, please <a [href]="[question.settings.cta.support_url]">{{ question.settings.cta.support_label }}</a>.</p>
        </div>
      </div>
    </div>

    <section *ngIf="!environment.production" class="margin-vertical-medium">
      <h4 (click)="test = !test" class="margin-bottom-xsmall">{{ test ? 'Hide test card numbers &#8613;' : 'Show test card numbers &#8615;' }}</h4>

      <div *ngIf="test">
        <div class="margin-bottom-medium">
          <h4>Success details</h4>
          <div class="grid margin-bottom-xxsmall">
            <div class="cell cell-large-col-span-4">082-082</div>
            <div class="cell cell-large-col-span-8">Australian BECS account BSB - Charges AUD</div>
          </div>
          <div class="grid margin-bottom-xxsmall">
            <div class="cell cell-large-col-span-4">012345678</div>
            <div class="cell cell-large-col-span-8">Australian BECS account number - Charges AUD</div>
          </div>
        </div>
        <div>
          <h4>Failure details</h4>
           <div class="grid margin-bottom-xxsmall">
            <div class="cell cell-large-col-span-4">123-123</div>
            <div class="cell cell-large-col-span-8">Can be any 3x-3x number that is not starting with 082-08x</div>
          </div>
          <div class="grid margin-bottom-xxsmall">
            <div class="cell cell-large-col-span-4">012345678</div>
            <div class="cell cell-large-col-span-8">Can be any number so long as BSB is incorrect</div>
          </div>
        </div>

      </div>
    </section>
  </div>

  <div *ngIf="raptorPaymentService.gocardlessShowAccount">
    <div class="grid">
      <div class="cell cell-small-col-span-6 cell-medium-col-span-4 cell-large-col-span-6">
        <label class="text-nowrap">Merchant&apos;s name</label>
        <p class="text-nowrap margin-top-xxsmall margin-bottom-none">Open Insurance Pty Ltd</p>
      </div>
      <div class="cell cell-small-col-span-6 cell-medium-col-span-4 cell-large-col-span-6">
        <label class="text-nowrap">Direct Debit User ID</label>
        <p class="text-nowrap margin-top-xxsmall margin-bottom-none">488299</p>
      </div>
    </div>

    <hr class="margin-vertical-small">

    <h3 class="margin-vertical-medium">Confirm your bank account details</h3>

    <div class="grid margin-bottom-medium">
      <div class="cell cell-small-col-span-6 cell-medium-col-span-4 cell-large-col-span-6">
        <label class="text-nowrap">Account name</label>
        <p class="text-nowrap margin-top-xxsmall margin-bottom-none">{{ raptorPaymentService.gocardlessAccount.account_name }}</p>
      </div>
      <div class="cell cell-small-col-span-6 cell-medium-col-span-4 cell-large-col-span-6">
        <label class="text-nowrap">Financial institution</label>
        <p class="text-nowrap margin-top-xxsmall margin-bottom-none">{{ raptorPaymentService.gocardlessAccount.bank_name }}</p>
      </div>
      <div class="cell cell-small-col-span-6 cell-medium-col-span-4 cell-large-col-span-6">
        <label class="text-nowrap">BSB</label>
        <p class="text-nowrap margin-top-xxsmall margin-bottom-none">{{ raptorPaymentService.gocardlessAccount.bsb }}</p>
      </div>
      <div class="cell cell-small-col-span-6 cell-medium-col-span-4 cell-large-col-span-6">
        <label class="text-nowrap">Account number</label>
        <p class="text-nowrap margin-top-xxsmall margin-bottom-none">{{ raptorPaymentService.gocardlessAccount.account_number}}</p>
      </div>
    </div>

    <a mat-button color="primary"type="button" class="small" (click)="changeAccountDetails()" class="change-account-details"><mat-icon class="chevron_left"></mat-icon>Change account details</a>

    <p class="margin-top-medium margin-bottom-large">By pressing "{{ option.submit_label || 'Confirm and pay' }}", you are providing us with a valid instruction for your direct debit, and you have understood and agreed to the terms and conditions of the debit arrangements between you and Open Insurance Pty Ltd, as set out in the "Paying your premium" and "If you have a complaint" sections of the <a (click)="openPdsDocument(pdsLink)">Product Disclosure Statement</a>, and the "Direct debit details" section of the Certificate of Insurance we'll provide you on purchase. By pressing "{{ option.submit_label || 'Confirm and pay' }}", you are agreeing electronically and you are aware that by doing so you are agreeing to a legally binding agreement.</p>
  </div>
</div>
